// Turns an uploaded file into plain text so it can feed the same regex-based
// extractors used for pasted text (parsePhoneList, parseIpList, ...) — one
// upload path for every tool that accepts free-form paste, no per-file-type
// parsing logic needed downstream.
//
// .txt / .csv / anything else: read as-is. The extractors scan for patterns
// anywhere in text, so CSV commas and headers are harmless noise to them.
// .xlsx: cells don't come as text, so ExcelJS reads every sheet and every row
// is flattened into a comma-joined line. ExcelJS is loaded lazily — most
// visits to these tools never touch a spreadsheet, matching the pattern
// already used for uploads in CDRAnalyzer.js / LPRPatternAnalyzer.js.

function cellToString(v) {
  if (v == null) return '';
  if (v instanceof Date) return v.toISOString();
  if (typeof v === 'object') return String(v.text || v.result || v.hyperlink || '');
  return String(v);
}

export async function extractTextFromFile(file) {
  const name = (file.name || '').toLowerCase();
  if (name.endsWith('.xlsx')) {
    const { default: ExcelJS } = await import('exceljs');
    const buf = await file.arrayBuffer();
    const wb = new ExcelJS.Workbook();
    await wb.xlsx.load(buf);
    const lines = [];
    wb.eachSheet(ws => {
      ws.eachRow(row => {
        const cells = row.values.slice(1).map(cellToString).filter(Boolean);
        if (cells.length) lines.push(cells.join(', '));
      });
    });
    return lines.join('\n');
  }
  return file.text();
}
